import { render, staticRenderFns } from "./codelist.vue?vue&type=template&id=c92a3ff8&scoped=true"
import script from "./codelist.vue?vue&type=script&lang=js"
export * from "./codelist.vue?vue&type=script&lang=js"
import style0 from "./codelist.vue?vue&type=style&index=0&id=c92a3ff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92a3ff8",
  null
  
)

export default component.exports